<!-- file-upload.component.html -->
<div class="file-upload-container">
  <!-- Drag and Drop Area -->
  <div
    cdkDropList
    (cdkDropListDropped)="onDrop($event)"
    class="drop-zone"
    [class.fileover]="isHovering"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
  >
    <p *ngIf="selectedFiles.length === 0">
      Drag and drop files here, or click to select files, you can upload
      multiple files at once.
    </p>
    <ul *ngIf="selectedFiles.length > 0">
      <li *ngFor="let file of selectedFiles">{{ file.name }}</li>
    </ul>
    <input type="file" (change)="onFileSelected($event)" multiple />
  </div>

  <!-- Upload Button -->
  <button
    mat-raised-button
    color="primary"
    [disabled]="!selectedFiles.length || isUploading"
    (click)="uploadFiles()"
  >
    {{ isUploading ? "Uploading..." : "Upload" }}
    <mat-progress-bar
      mode="indeterminate"
      *ngIf="isUploading"
    ></mat-progress-bar>
  </button>
  <!-- Display Upload Progress -->
  <div *ngIf="uploadProgress.length && isUploading" class="uploading-files">
    <h3>Upload Progress:</h3>
    <ul>
      <li *ngFor="let progress of uploadProgress">
        {{ progress.fileName }}: {{ progress.percentage }}%
      </li>
    </ul>
  </div>

  <!-- Display Download URLs -->
  <div *ngIf="downloadURLs.length" class="uploaded-files">
    <h3>Uploaded Files:</h3>
    <ul>
      <li *ngFor="let data of downloadURLs">
        <a [href]="data.url" target="_blank">{{ data.fileName }}</a>
      </li>
    </ul>
  </div>
</div>
